import React, { useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import { AppContext, DispatchContext } from "../AppContext";
import * as actions from "../actions/actions";
import {  FormHelperText, TextField, MenuItem } from "@material-ui/core";
import IconLabel from './IconLabel';

export default function LicenseQuotePanel() {
    const useStyles = makeStyles((theme) => ({
      root: {
        display: "grid",  // https://grid.layoutit.com/?id=54hwQfb
        gridTemplateColumns: "1fr 1fr",
        gridTemplateRows: "60px min-content min-content min-content 1fr",
        gridTemplateAreas: `
          "infoBar infoBar"
          "namePanel studentNumberPanel"
          "mailPanel plagCountPanel"
          "orgNamePanel pageCountPanel"
          "orgTypePanel remarksPanel"
          `,
        gap: "12px",
      },
      infoBar: {
        gridArea: "infoBar",
        overflow: "auto",
        alignSelf: "top",
        justifySelf: "center"
      },
      namePanel: {
        gridArea: "namePanel",
        overflow: "auto",
      },
      orgNamePanel: { gridArea: "orgNamePanel" },
      orgTypePanel: { gridArea: "orgTypePanel" },
      checkNumberPanel: { gridArea: "checkNumberPanel" },
      mailPanel: { gridArea: "mailPanel" },
      studentNumberPanel: { gridArea: "studentNumberPanel" },
      pageCountPanel: { gridArea: "pageCountPanel" },
      plagCountPanel: { gridArea: "plagCountPanel" },      
      fullWidth: { width: "100%" },
      formHelper: {
        color: theme.palette.secondary.light, 
        lineHeight: "14px"
      }
    }));
  
    const state = useContext(AppContext);
    const s = state.strings;
    const dispatch = useContext(DispatchContext);
    const classes = useStyles();
  
    const handleFormChange = (newValue, key) => {
      dispatch(actions.setCheckoutDetails({ education: { ...state.checkout.education, [key]: newValue } }));
    }
  
    return (
      <div className={classes.root}>
        <div className={classes.infoBar}>
          <IconLabel label={s.quotePanel.hint}  />
        </div>
        <div className={classes.namePanel}>
          <TextField className={classes.fullWidth} size="small" required label={s.quotePanel.contact}
            value={state.checkout.education.contactName}
            onChange={(e) => handleFormChange(e.target.value, "contactName")}
          />
        </div>
        <div classname={classes.mailPanel}>
          <TextField className={classes.fullWidth} size="small" required label={s.quotePanel.mail}
            value={state.checkout.education.contactMail}
            onChange={(e) => handleFormChange(e.target.value, "contactMail")}
          />
          <FormHelperText className={classes.formHelper}>{s.quotePanel.mailHint}</FormHelperText>          
        </div>
        <div className={classes.orgNamePanel}>
          <TextField className={classes.fullWidth} size="small" required label={s.quotePanel.orgName}
            value={state.checkout.education.orgName}
            onChange={(e) => handleFormChange(e.target.value, "orgName")}
          />
          <FormHelperText className={classes.formHelper}>{s.quotePanel.orgNameHint}</FormHelperText>
        </div>
        <div className={classes.orgTypePanel}>
            <TextField className={classes.fullWidth} select size="small" required label={s.quotePanel.orgType}
              value={state.checkout.education.orgType}
              onChange={(e) => handleFormChange(e.target.value, "orgType")} 
              >
              <MenuItem key={1} value={1}>{s.quotePanel.university}</MenuItem>
              <MenuItem key={2} value={2}>{s.quotePanel.school}</MenuItem>
              <MenuItem key={3} value={3}>{s.quotePanel.other}</MenuItem>
            </TextField>
        </div>
        <div className={classes.studentNumberPanel}>
          <TextField className={classes.fullWidth} size="small" label={s.quotePanel.studentCount}
            value={state.checkout.education.studentNumber}
            onChange={(e) => handleFormChange(e.target.value, "studentCount")}
          />
          <FormHelperText className={classes.formHelper}>{s.quotePanel.relevantStudentCount}</FormHelperText>
        </div>
        <div className={classes.plagCountPanel}>
          <TextField className={classes.fullWidth} size="small" label={s.quotePanel.plagCheckCount}
            value={state.checkout.education.plagCheckCount}
            onChange={(e) => handleFormChange(e.target.value, "plagCheckCount")}
          />
          <FormHelperText className={classes.formHelper}>{s.quotePanel.plagCheckCountHint}</FormHelperText>
        </div>
        <div className={classes.pageCountPanel}>
          <TextField className={classes.fullWidth} size="small" label={s.quotePanel.pageCount}
            value={state.checkout.education.pageCount}
            onChange={(e) => handleFormChange(e.target.value, "pageCount")}
          />
          <FormHelperText className={classes.formHelper}>{s.quotePanel.pageCountHint}</FormHelperText>
        </div>
        <div className={classes.remarksPanel}>
          <TextField className={classes.fullWidth} multiline size="small" label={s.quotePanel.comments}
            value={state.checkout.education.remarks}
            onChange={(e) => handleFormChange(e.target.value, "remarks")}
          />
        </div>
      </div>
    );
  }
  